import React from 'react';
import AllProducts from '../components/AllProducts';
import Layout from '../components/Layout';

function Products() {
    return (
        <Layout>
           <AllProducts />
        </Layout>
    );
}

export default Products;